export default "__VITE_ASSET__CXudBEei__"